import styled from "styled-components";
import {BaseContainer} from "../CustomerLayout.styles";

export const SubPageContainer = styled(BaseContainer)`
    //above 1440px
    @media screen and (min-width: 1440px) {
        max-width: 1440px;
        padding: 0 48px;
    }

    //992px and 1440px
    @media screen and (min-width: 992px) and (max-width: 1440px) {
        max-width: 1440px;
        padding: 0 48px;
    }

    //768px and 992px
    @media screen and (min-width: 768px) and (max-width: 992px) {
        max-width: 100%;
        padding: 0 32px;
    }

    //576px and 768px
    @media screen and (min-width: 576px) and (max-width: 768px) {
        max-width: 100%;
        padding: 0 32px;
    }

    //576px and below
    @media screen and (max-width: 576px) {
        max-width: 100%;
        padding: 0 32px;
    }
`;

export const SubPageContent = styled.div`
    //dimensions
    width: 100%;
    height: 100%;

    //flex
    display: flex;
    flex-direction: column;
    align-items: center;

    z-index: 2;
`;

export const Content = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 35px;

    /* Reduce margin for manual delivery page specifically */
    .create-delivery-request-customer & {
        margin-top: 10px;

        /* Compact form styling for customer theme */
        .ant-form-item {
            margin-bottom: 6px !important;
        }

        .ant-form-item:last-child {
            margin-bottom: 0px !important;
        }

        .ant-input {
            padding: 4px 8px !important;
        }

        .ant-select {
            .ant-select-selector {
                padding: 2px 8px !important;
                min-height: 28px !important;
            }
        }

        .ant-row {
            margin-bottom: 0px !important;
        }

        /* Reduce spacing between InputRows specifically */
        [data-testid="createDeliveryRequest"]
            .ant-row:not(.ant-row-start):not(.ant-row-center):not(.ant-row-end) {
            margin-bottom: 2px !important;
        }

        h5 {
            margin-bottom: 2px !important;
            margin-top: 4px !important;
            font-size: 13px !important;
        }
    }
`;

export const PageHeaderRow = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: auto auto auto;
    margin-top: 35px;
`;
